<template>
    <AppLayout>
        <div class="task-page">
            <div class="container">
                <div class="profile-card">

                    <div class="profile-head">
                        <div class="profile-head-left">
                            <div class="avatar">

                                <img :src="talent.avatar" alt="" />
                            </div>

                            <div class="profile-basic">
                                <div class="name">{{ talent.name }}</div>

                                <div class="basic-row">
                                    <div class="basic-item">
                                        <span class="basic-label">毕业院校：</span>
                                        <span class="basic-value">{{ talent.school || '-' }}</span>
                                    </div>
                                    <div class="basic-item">
                                        <span class="basic-label">时薪：</span>
                                        <span class="basic-value">¥ {{ talent.hourlyRate }}/时</span>
                                    </div>
                                </div>

                                <div class="skills-row">
                                    <div class="skills-label">拥有技能：</div>
                                    <div class="skills">
                                        <span v-for="t in talent.skills" :key="t" class="skill-pill">{{ t }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="profile-head-right">
                            <button class="contact-btn" type="button" @click="openQuote">
                                立即联系
                            </button>
                        </div>
                    </div>

                   
                    <div class="block">
                        <div class="block-title">工作经历</div>

                        <div class="work-list">
                            <div v-for="(w, idx) in talent.workList" :key="idx" class="work-item">
                                <div class="work-time">{{ formatRange(w.start, w.end, w.isNow) }}</div>

                                <div class="work-main">
                                    <div class="work-topline">
                                        <div class="work-position">{{ w.position }}</div>
                                        <div class="work-company">{{ w.company }}</div>
                                    </div>

                                    <div class="work-desc">
                                        {{ w.description }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="block" style="margin-top: 26px;">
                        <div class="block-title">作品介绍</div>

                        <div class="portfolio-desc">
                            {{ talent.portfolioDesc }}
                        </div>

                        <div class="portfolio-grid">
                            <div v-for="(img, i) in talent.portfolioImages" :key="img + i" class="portfolio-item">
                                <img :src="img" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <el-dialog v-model="quoteOpen" width="640px" align-center :teleported="false" :show-close="false"
                :close-on-click-modal="true" :close-on-press-escape="true" class="quote-dialog">
                <div class="quote-body">
                    <div class="quote-title">立即报价</div>

                    <el-form ref="quoteFormRef" class="quote-form" :model="quoteForm" :rules="quoteRules"
                        label-position="top" status-icon :hide-required-asterisk="false" @submit.prevent>
                        <el-form-item label="金额" prop="price" required>
                            <el-input v-model.trim="quoteForm.price" placeholder="请输入" />
                        </el-form-item>

                        <el-form-item label="预计完成时间" prop="eta" required>
                            <el-date-picker v-model="quoteForm.eta" type="date" placeholder="请选择" format="YYYY-MM-DD"
                                value-format="YYYY-MM-DD" style="width: 100%" />
                        </el-form-item>

                        <el-button class="quote-submit" type="success" :loading="submitting" @click="submitQuote">
                            提交
                        </el-button>
                    </el-form>
                </div>
            </el-dialog>
            <el-dialog v-model="successOpen" width="420px" align-center :teleported="false" modal :lock-scroll="true"
                :show-close="false" :close-on-click-modal="true" :close-on-press-escape="true" class="success-dialog">
                <div class="success-body">
                    <img class="success-icon" src="../assets/Frame 9800.png" alt="" />
                    <div class="success-title">报价成功</div>
                    <div class="success-desc">报价成功，等待甲方回复</div>

                    <div class="success-actions">
                        <el-button type="success" class="success-cta" @click="continueBrowse">继续浏览</el-button>
                        <el-button type="success" link @click="goHome">返回首页</el-button>
                    </div>
                </div>
            </el-dialog>
        </div>
    </AppLayout>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import AppLayout from '@/layouts/AppLayout.vue'

const router = useRouter()

/** 示例：人才资料数据（替换你原 task） */
const talent = reactive({
    id: 1,
    name: '姓名',
    school: '华东政法大学',
    hourlyRate: 100,
    avatar:
        'https://images.unsplash.com/photo-1524504388940-b1c1722653e1?auto=format&fit=crop&w=240&q=80',
    skills: ['Axure', 'Sketch', 'XD', 'Figma', '交互设计', '界面设计'],
    workList: [
        {
            start: '2024',
            end: '',
            isNow: true,
            position: 'UI设计师/产品',
            company: 'XXXXXX科技有限公司',
            description:
                '与客户沟通,进行需求分析并提出合理方案,进行项目讨论梳理产品逻辑并产出高保真原型进行需求确认。与客户沟通,进行需求分析并提出合理方案,进行项目讨论梳理产品逻辑并产出高保真原型进行需求确认。与客户沟通,进行需求分析并提出合理方案,进行项目讨论梳理产品逻辑并产出高保真原型进行需求确认。'
        },
        {
            start: '2022',
            end: '2024',
            isNow: false,
            position: 'UI设计师/产品',
            company: 'XXXXXX科技有限公司',
            description:
                '与客户沟通,进行需求分析并提出合理方案,进行项目讨论梳理产品逻辑并产出高保真原型进行需求确认。与客户沟通,进行需求分析并提出合理方案,进行项目讨论梳理产品逻辑并产出高保真原型进行需求确认。与客户沟通,进行需求分析并提出合理方案,进行项目讨论梳理产品逻辑并产出高保真原型进行需求确认。'
        },
        {
            start: '2020',
            end: '2022',
            isNow: false,
            position: 'UI设计师/产品',
            company: 'XXXXXX科技有限公司',
            description:
                '与客户沟通,进行需求分析并提出合理方案,进行项目讨论梳理产品逻辑并产出高保真原型进行需求确认。与客户沟通,进行需求分析并提出合理方案,进行项目讨论梳理产品逻辑并产出高保真原型进行需求确认。与客户沟通,进行需求分析并提出合理方案,进行项目讨论梳理产品逻辑并产出高保真原型进行需求确认。'
        },
        {
            start: '2015',
            end: '2020',
            isNow: false,
            position: 'UI设计师/产品',
            company: 'XXXXXX科技有限公司',
            description:
                '与客户沟通,进行需求分析并提出合理方案,进行项目讨论梳理产品逻辑并产出高保真原型进行需求确认。与客户沟通,进行需求分析并提出合理方案,进行项目讨论梳理产品逻辑并产出高保真原型进行需求确认。与客户沟通,进行需求分析并提出合理方案,进行项目讨论梳理产品逻辑并产出高保真原型进行需求确认。'
        }
    ],
    portfolioDesc:
        '作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍作品介绍',
    portfolioImages: [
        'https://images.unsplash.com/photo-1558655146-9f40138edfeb?auto=format&fit=crop&w=600&q=80',
        'https://images.unsplash.com/photo-1515879218367-8466d910aaa4?auto=format&fit=crop&w=600&q=80',
        'https://images.unsplash.com/photo-1559028012-481c04fa702d?auto=format&fit=crop&w=600&q=80'
    ]
})

function formatRange(start, end, isNow) {
    const s = start ? String(start).replace('-', '.') : ''
    if (isNow) return `${s} — 至今`
    const e = end ? String(end).replace('-', '.') : ''
    return `${s} — ${e || ''}`.trim()
}

/* ===== 报价弹窗逻辑（保留你原来的） ===== */
const quoteOpen = ref(false)
const successOpen = ref(false)
const submitting = ref(false)

const quoteFormRef = ref(null)
const quoteForm = reactive({
    price: '',
    eta: '' // YYYY-MM-DD
})

function validateMoney(_rule, v, cb) {
    const val = String(v ?? '').trim()
    if (!val) return cb(new Error('请输入金额'))
    if (!/^\d+(\.\d{1,2})?$/.test(val)) return cb(new Error('金额格式不正确（最多两位小数）'))
    const n = Number(val)
    if (!Number.isFinite(n) || n <= 0) return cb(new Error('金额必须大于 0'))
    cb()
}

function validateEta(_rule, v, cb) {
    const val = String(v ?? '').trim()
    if (!val) return cb(new Error('请选择预计完成时间'))
    cb()
}

const quoteRules = reactive({
    price: [
        { required: true, message: '请输入金额', trigger: 'blur' },
        { validator: validateMoney, trigger: ['blur', 'change'] }
    ],
    eta: [
        { required: true, message: '请选择预计完成时间', trigger: 'change' },
        { validator: validateEta, trigger: 'change' }
    ]
})

function openQuote() {
    quoteForm.price = ''
    quoteForm.eta = ''
    quoteOpen.value = true
}

async function submitQuote() {
    if (!quoteFormRef.value) return
    try {
        await quoteFormRef.value.validate()
        submitting.value = true
        await new Promise((r) => setTimeout(r, 600))
        quoteOpen.value = false
        successOpen.value = true
    } catch {
        // 校验不通过：自动显示错误提示
    } finally {
        submitting.value = false
    }
}

function continueBrowse() {
    successOpen.value = false
}

function goHome() {
    successOpen.value = false
    router.push('/home')
}
</script>

<style lang="scss" scoped>
/* 页面背景与左右留白（对齐 header） */
.task-page {
    min-height: calc(100vh - 64px);
    padding: 28px 240px 64px;
    background: #ffffff;

    @media (max-width: 1400px) {
        padding-left: 80px;
        padding-right: 80px;
    }

    @media (max-width: 960px) {
        padding: 18px 16px 48px;
    }
}

.container {
    width: 100%;
}

/* ✅ 整体外框卡片（UI图：大白卡 + 细边框） */
.profile-card {
    max-width: 1180px;
    margin: 0 auto;
    background: #ffffff;
    border: 1px solid #e9e9e9;
    border-radius: 8px;
    padding: 34px 42px 40px;

    @media (max-width: 960px) {
        padding: 18px 16px 22px;
    }
}

/* 顶部信息区 */
.profile-head {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 18px;
    padding-bottom: 18px;
}

.profile-head-left {
    display: flex;
    align-items: flex-start;
    gap: 22px;
    min-width: 0;
}

.avatar {
    width: 88px;
    height: 88px;
    border-radius: 50%;
    overflow: hidden;
    background: #f3f3f3;
    flex: 0 0 auto;
}

.avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.profile-basic {
    min-width: 0;
}

.name {
    font-weight: 600;
    font-size: 20px;
    color: #111111;
    margin: 6px 0 16px;
}

.basic-row {
    display: flex;
    align-items: center;
    gap: 36px;
    flex-wrap: wrap;
    margin-bottom: 10px;
}

.basic-item {
    font-size: 14px;
    color: #8c8c8c;
}

.basic-label {
    color: #a5a5a5;
}

.basic-value {
    color: #111111;
}

.skills-row {
    display: flex;
    align-items: center;
    gap: 12px;
}

.skills-label {
    font-size: 14px;
    color: #a5a5a5;
    // padding-top: 6px;
    white-space: nowrap;
}

.skills {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.skill-pill {
    height: 24px;
    padding: 0 12px;
    border-radius: 4px;
    background: #f6f6f6;
    font-size: 14px;
    color: #676767;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

/* 右侧按钮 */
.contact-btn {
    width: 172px;
    height: 44px;
    border: none;
    border-radius: 6px;
    background: #4caf50;
    color: #ffffff;
    font-size: 14px;
    cursor: pointer;
    transition: 0.2s ease;
}

.contact-btn:hover {
    filter: brightness(0.98);
}

.contact-btn:active {
    transform: translateY(1px);
}

/* 分块标题 */
.block {
    margin-top: 10px;
}

.block-title {
    font-weight: 600;
    font-size: 18px;
    color: #111111;
    margin: 14px 0 16px;
}

/* 工作经历列表（UI图：左时间、右内容+灰底描述） */
.work-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.work-item {
    display: grid;
    grid-template-columns: 120px 1fr;
    gap: 16px;

    @media (max-width: 720px) {
        grid-template-columns: 1fr;
    }
}

.work-time {
    font-size: 14px;
    color: #6D6D6D;
    padding-top: 6px;
}

.work-topline {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 10px;
}

.work-position {
    font-weight: 600;
    font-size: 14px;
    color: #2b2f33;
}

.work-company {
    font-size: 14px;
    color: #6f6f6f;
}

.work-desc {
    background: #f7f7f7;
    border-radius: 8px;
    padding: 12px 14px;
    font-size: 14px;
    color: #555555;
    line-height: 20px;
}

/* 作品介绍 */
.portfolio-desc {
    background: #f7f7f7;
    border-radius: 8px;
    padding: 14px;
    font-size: 14px;
    color: #555555;
    line-height: 20px;
}

.portfolio-grid {
    margin-top: 14px;
    display: flex;
    // grid-template-columns: repeat(3, minmax(0, 1fr));
    // gap: 12px;

    @media (max-width: 720px) {
        grid-template-columns: 1fr;
    }
}

.portfolio-item {
    width: 150px;
    height: 90px;
    overflow: hidden;
    margin-right: 4px;
    border-radius: 8px 8px 8px 8px;
}

.portfolio-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

/* ===== 下面弹窗样式：沿用你原来的 ===== */
:deep(.quote-dialog .el-dialog) {
    border-radius: 8px;
    overflow: hidden;
}

:deep(.quote-dialog .el-dialog__header) {
    display: none;
}

:deep(.quote-dialog .el-dialog__body) {
    padding: 0;
}

.quote-body {
    padding: 32px 63px;
}

.quote-title {
    text-align: center;
    font-weight: 600;
    font-size: 24px;
    color: #333333;
    margin: 0px 0 18px;
}

:deep(.quote-dialog .quote-form) {
    .el-form-item {
        margin-bottom: 18px;
    }

    .el-form-item__label {
        font-weight: 500;
        font-size: 14px;
        color: #303133;
        padding-bottom: 6px;
    }

    .el-form-item__content {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        position: static !important;
    }

    .el-form-item__error,
    .el-form-item__error--inline {
        position: static !important;
        display: block !important;
        width: 100%;
        margin-top: 6px;
        padding: 0;
        line-height: 1.2;
        white-space: normal;
        z-index: auto !important;
        transform: none !important;
        top: auto !important;
        left: auto !important;
        right: auto !important;
        bottom: auto !important;
    }

    .el-input__wrapper,
    .el-date-editor .el-input__wrapper {
        min-height: 48px;
        border-radius: 6px;
        box-sizing: border-box;
    }
}

:deep(.quote-submit.el-button) {
    height: 48px;
    background: #4caf50;
    border-radius: 4px;
    width: 100%;
    margin-top: 36px;
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
}

:deep(.success-dialog .el-dialog) {
    border-radius: 8px;
    overflow: hidden;
}

:deep(.success-dialog .el-dialog__header) {
    display: none;
}

:deep(.success-dialog .el-dialog__body) {
    padding: 32px 63px;
}

.success-body {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
}

.success-icon {
    margin: 0px 0 28px;
    width: 100px;
    height: 100px;
}

.success-title {
    font-weight: 400;
    font-size: 20px;
    color: #2e323e;
    margin-bottom: 6px;
}

.success-desc {
    font-weight: 400;
    font-size: 16px;
    color: #9899a2;
    margin-bottom: 48px;
}

.success-actions {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 56px;
    align-items: center;
}

:deep(.success-cta.el-button) {
    width: 260px;
    height: 41px;
    background: linear-gradient(39deg, #4caf50 0%, #91df35 100%);
    box-shadow: 2px 2px 4px 0px rgba(24, 144, 255, 0.1);
    border-radius: 200px;
}
</style>